import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { AiOutlineClose, AiOutlineArrowRight } from 'react-icons/ai';
import { FaFacebookF, FaInstagram, FaTwitter } from 'react-icons/fa';
import { RxDotFilled } from 'react-icons/rx';

import { useCikContext } from '../../Context/CentralIndustrisContaxtProvider';
import logo from '../../assets/logoblack.png';
import './Slider.css';

function Slider() {
  const { navStatus, setNavStatus } = useCikContext();

  const closeSlider = () => {
    setNavStatus(false);
  };

  return (
    <div className={`slider ${navStatus ? 'slider-active' : ''}`} aria-hidden={!navStatus}>
      
      {/* Header */}
      <div className="slider__header">
        <img src={logo} alt="Central Industries Kandy Logo" className="slider__logo" />
        <button className="slider__close" onClick={closeSlider} aria-label="Close menu">
          <AiOutlineClose aria-hidden="true" />
        </button>
      </div>

      {/* Navigation Links (Synchronized with Nav Bar) */}
      <div className="slider__links">
        
        <div className="slider__link-item">
          <AnchorLink href="#Home" className="slider__link" onClick={closeSlider}>
            Home <AiOutlineArrowRight aria-hidden="true" />
          </AnchorLink>
        </div>

        <div className="slider__link-item">
          <AnchorLink href="#Solutions" className="slider__link" onClick={closeSlider}>
            Services <AiOutlineArrowRight aria-hidden="true" />
          </AnchorLink>
        </div>

        <div className="slider__link-item">
          <AnchorLink href="#Products" className="slider__link" onClick={closeSlider}>
            Products <AiOutlineArrowRight aria-hidden="true" />
          </AnchorLink>
        </div>

        <div className="slider__link-item">
          <AnchorLink href="#About" className="slider__link" onClick={closeSlider}>
            About <AiOutlineArrowRight aria-hidden="true" />
          </AnchorLink>
        </div>

        <div className="slider__link-item">
          <AnchorLink href="#Gallery" className="slider__link" onClick={closeSlider}>
            Gallery <AiOutlineArrowRight aria-hidden="true" />
          </AnchorLink>
        </div>

        <div className="slider__link-item">
          <AnchorLink href="#Contact" className="slider__link" onClick={closeSlider}>
            Contact <AiOutlineArrowRight aria-hidden="true" />
          </AnchorLink>
        </div>

      </div>

      {/* Footer Social */}
      <div className="slider__footer">
        <a href="https://www.facebook.com/p/Central-Industries-Kandy-Private-Limited-100063541863946/" target="_blank" rel="noreferrer" className="slider__social-link" aria-label="Facebook">
          <FaFacebookF aria-hidden="true" />
        </a>
        <a href="https://www.instagram.com/" target="_blank" rel="noreferrer" className="slider__social-link" aria-label="Instagram">
          <FaInstagram aria-hidden="true" />
        </a>
        <a href="https://twitter.com/" target="_blank" rel="noreferrer" className="slider__social-link" aria-label="Twitter">
          <FaTwitter aria-hidden="true" />
        </a>
      </div>

    </div>
  );
}

export default Slider;